import { customGetExecute } from 'services/api/microfwk';
import _ from 'lodash';

export const getRecordingList = (params = {}) =>
  customGetExecute('/services/recordings/list?api_version=v5.94', { ...params })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
